import { useEffect, useMemo, useState } from 'react';
import { hrApi } from '@/api/hr.api';
import { SearchableSelect } from '@/components/ui/SearchableSelect';
import type { SelectOption } from '@/components/ui/Select';
import { showApiError } from '@/utils/apiError';

type LeaveTypeRow = { id: number; name?: string; typeName?: string; code?: string };

export function LeaveTypeSelect({
  label = 'Leave type',
  value = '',
  onChange,
  placeholder = 'Select leave type',
  className,
  required,
}: {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  className?: string;
  required?: boolean;
}) {
  const [types, setTypes] = useState<LeaveTypeRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    hrApi
      .listLeaveTypes()
      .then((rows) => setTypes(rows as LeaveTypeRow[]))
      .catch((err) => showApiError(err, 'Failed to load leave types'))
      .finally(() => setLoading(false));
  }, []);

  const options: SelectOption[] = useMemo(
    () =>
      types.map((type) => ({
        value: String(type.id),
        label: type.name ?? type.typeName ?? type.code ?? `Type #${type.id}`,
      })),
    [types],
  );

  return (
    <SearchableSelect
      className={className}
      label={label}
      required={required}
      value={value}
      onChange={onChange}
      options={options}
      placeholder={placeholder}
      loading={loading}
      searchPlaceholder="Search leave types…"
      emptyMessage="No leave types found"
    />
  );
}
